"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const controlCreateEventCallbackFromDefinition_1 = __importDefault(require("./controlCreateEventCallbackFromDefinition"));
const emptyControlEvents = {};
const controlCreateEventCallbacksFromDefinition = ({ store, processor, functionsAreEnabled, functionsDefinitions, controlId, events, }) => {
    if (!functionsAreEnabled || !events) {
        return emptyControlEvents;
    }
    return Object.entries(events)
        .reduce((newEvents, [controlEventKey, controlEvent]) => (Object.assign(Object.assign({}, newEvents), { [controlEventKey]: (0, controlCreateEventCallbackFromDefinition_1.default)({
            controlEvent,
            controlId,
            functionsDefinitions,
            processor,
            appStateStore: store,
        }) })), {});
};
exports.default = controlCreateEventCallbacksFromDefinition;
